import React from 'react';

const InfoColumns = ({title = '', columns = []}) => {
    return (
        <React.Fragment>
            <div className='stats-title'>{title}</div>
            <div className='stats-info-container'>
                {columns.map((column, index) => (
                    <div className='stats-info-columns' key={index}>
                        <div className='stats-info-value'>
                            {column.value}
                        </div>
                        <div className='stats-info-title'>
                            {column.key}
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
};

export default InfoColumns;